export const classes = {
  root: {
    border: 'none',
    width: '100%',
    minWidth: 'auto',
    position: 'relative',
  },
};
